import axios from "axios";

export const uploadFile = async (
  file,
  temporada,
  marca,
  designer = "", // Valor predeterminado vacío si no está definido
  productName,
  folder,
  productId,
  muestraId,
  muestraName
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("temporada", temporada);
  formData.append("marca", marca);
  formData.append("designer", designer || "");
  formData.append("productName", productName);
  formData.append("folder", folder);
  formData.append("productId", productId);
  if (muestraId) formData.append("muestraId", muestraId);
  if (muestraName) formData.append("muestraName", muestraName);

  const token = localStorage.getItem("token");

  if (
    !file ||
    !temporada ||
    !marca ||
    !designer ||
    !productName ||
    !folder ||
    !productId
  ) {
    console.warn("Faltan datos para la subida de archivos");
    return;
  }

  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/files/upload`,
      formData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (error) {
    console.error(
      "Error al subir el archivo desde el frontend:",
      error.response?.data || error
    );
  }
};

export const downloadFile = async (
  temporada,
  marca,
  designer,
  productName,
  folder,
  fileName
) => {
  const token = localStorage.getItem("token");

  if (!token) {
    console.warn("Token no disponible para la descarga.");
    return;
  }

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/files/download/${temporada}/${marca}/${designer}/${productName}/${folder}/${fileName}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob", // Para manejar archivos binarios
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error("Error al descargar el archivo:", error);
  }
};

export const getFiles = async (
  temporada,
  marca,
  designer,
  productName,
  folder
) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/files/${temporada}/${marca}/${designer}/${productName}/${folder}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

export const getFilesByProduct = async (
  productId,
  temporada,
  marca,
  designer
) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/files/${productId}/${temporada}/${marca}/${designer}`
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener archivos:", error);
    throw error;
  }
};

export const getFileContent = async (filePath) => {
  const token = localStorage.getItem("token");

  if (!token) {
    console.warn("Token no disponible para la descarga.");
    return;
  }

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/files/readfile?path=${filePath}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error al encontrar el archivo:", error);
  }
};

export const deleteFile = async (
  productId,
  temporada,
  marca,
  designer,
  folder,
  fileName
) => {
  const token = localStorage.getItem("token");

  await axios.delete(
    `${process.env.REACT_APP_API_URL}/api/files/delete/${productId}/${temporada}/${marca}/${designer}/${folder}/${fileName}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const deleteSpecificFile = async (
  temporada,
  marca,
  designer,
  productName,
  folder,
  fileName
) => {
  const token = localStorage.getItem("token");

  if (!token) {
    console.warn("Token no disponible para la eliminación.");
    throw new Error("Token de autenticación no encontrado.");
  }

  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/files/delete/${temporada}/${marca}/${designer}/${productName}/${folder}/${fileName}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error al eliminar el archivo:",
      error.response?.data || error
    );
    throw error;
  }
};
